const UibDatepickerConfig = [
    "uibDatepickerConfig",
    function (uibDatepickerConfig) {
        uibDatepickerConfig.showWeeks = false;
    }
];
export default UibDatepickerConfig;
